var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoltSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9453 10.7906C15.8605 10.6229 15.6884 10.5168 15.4999 10.5163H12.9979V7.52377C13.0089 7.2989 12.8675 7.09454 12.6526 7.02502C12.4465 6.95743 12.2202 7.02994 12.0922 7.20457L8.0889 12.6908C7.9868 12.8379 7.97153 13.0282 8.04887 13.1896C8.12037 13.3748 8.29528 13.5002 8.49423 13.5088H10.9963V16.5012C10.9964 16.717 11.1358 16.9082 11.3416 16.9751C11.3918 16.9906 11.4441 16.999 11.4967 17C11.6568 17.0004 11.8075 16.9244 11.902 16.7955L15.9053 11.3093C16.0152 11.1576 16.0307 10.9573 15.9453 10.7906ZM11.9963 14.9698L11.9963 13.5088V12.5088H9.45937L11.9985 9.02933L11.9979 10.5163V11.5163H14.5163L11.9963 14.9698Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltSmall);
export default ForwardRef;